import Login from "./Login";
import { withNavigation } from "../../Common/withNavigation";
import {connect} from "react-redux";

const mapStateToProps = (state) => {
  //   console.log("Product---->", state.product.editproduct);
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(Login)
);
